const initialState = {
  insuranceProviderList: [],
}

const insuranceProvider = (state = initialState, action = {}) => {
  if (action.type === 'INSURANCE_PROVIDER_LIST') {
    return { ...state, insuranceProviderList: action.payload }
  } else {
    return state
  }
}

export default insuranceProvider
